// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"756":"7ba5950f","973":"9cc18f28"}[chunkId] + ".chunk.css";
};